// 剣舞の残りの仮の FX（引き寄せの帯・暗器の小刀）を、描いた絵へ替える (10-31)。
//   11-01 作者の答え：帯は描いた絵 (太さ 16)・小刀は白い丸を消した描いた絵 (見せ直しで A) が配布版の既定。?bladeFxRest=sash で小刀だけ前の見た目、?bladeFxRest=now で両方とも前の見た目。
//   作者の決め事：質感は描いた絵から、出る・動く・消えるはコードで。線・輪・光る縁の「コードで描いた感」を出さない。
//   帯 = 立ち絵の腰の藤色の帯がほどけて飛ぶ布。光らせない (光る紫は とどめ・弾きの合図だけ)。描いた帯を曲線に沿って縦に細く切って並べる。
//   小刀 = 立ち絵の右手の剣と同じ剣を描いた1枚。光と尾の粒は剣舞の花びらの glow・glint の絵。
//   絵 = public/fx/blade-dancer/ (元の絵は そざい/concept/blade-pull-sash-1031/・blade-throw-knife-1031/。Codex Sol で描いた)。
//   render.ts を読み込まない (帯と小刀の描画から呼ぶので、循環を作らない)。
/** now = 前の見た目・sash = 帯だけ描いた絵 (11-01 の入れ始め)・paint = 帯と小刀の両方 (配布版)。 */
export type BladeFxRest = 'now' | 'sash' | 'paint'
let look: BladeFxRest = 'paint'
/** 帯の太さ (px)。描いた布は 7px では質感が出ないので 12〜18 を比べ、11-01 作者の答えで 16 (?bladeSashW=8〜30 で変えられる)。 */
let sashWidth = 16

export function parseBladeFxRest(v: string | null): BladeFxRest { return v === 'now' ? 'now' : v === 'sash' ? 'sash' : 'paint' }
export function parseBladeSashWidth(v: string | null): number {
  const n = Number(v)
  return Number.isFinite(n) && n >= 8 && n <= 30 ? n : 16
}
export function setBladeFxRest(v: BladeFxRest, width = 16): void {
  look = v
  sashWidth = width
  if (v !== 'now') preloadBladeFxRest()
}
/** 帯を描いた絵で描くか。 */
export function bladeSashPaintOn(): boolean { return look !== 'now' }
/** 小刀と光の粒を描いた絵で描くか。 */
export function bladeKnifePaintOn(): boolean { return look === 'paint' }
export function bladeSashWidth(): number { return sashWidth }

// 絵の寸法 (抜いて切った後の実測・10-31)。帯の切れ端は高さ 64 のうち布の幅が 37.7。先端は同じ縮尺で、左の切り口の中心が cutY。
export const SASH_STRIP = { h: 64, band: 37.7 }
export const SASH_TIPS = [{ name: 'sash_tip_1', cutY: 78.8 }, { name: 'sash_tip_2', cutY: 51.3 }] as const
/** 小刀の絵 (320×34)。柄頭が左、刃先が右。 */
export const KNIFE_IMG = { w: 320, h: 34 }

const cache: Record<string, HTMLImageElement> = {}
/** 絵を返す。読み込み前・テスト (node) では null (呼ぶ側は今の描き方へ戻す)。 */
export function bladeFxRestImg(path: string): HTMLImageElement | null {
  if (typeof Image === 'undefined') return null
  let img = cache[path]
  if (!img) { img = new Image(); img.src = `/fx/${path}.png`; cache[path] = img }
  return img.complete && img.naturalWidth > 0 ? img : null
}
function preloadBladeFxRest(): void {
  for (const p of ['blade-dancer/sash_strip', 'blade-dancer/sash_tip_1', 'blade-dancer/sash_tip_2', 'blade-dancer/knife', 'blade-petals/glow_1', 'blade-petals/glow_2', 'blade-petals/glint_1']) bladeFxRestImg(p)
}
